import {
  CampaignType,
  campaignTypeLabels,
} from '@features/campaign-list/domain/campaign';
import { FilterContext } from '@features/campaign-list/stores/filter-context';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { ChangeEvent, useContext } from 'react';
import { useFeatures } from '@utils/hooks';

export const CampaignTypeRadioGroup = () => {
  const { filterState, dispatch } = useContext(FilterContext);
  const features = useFeatures();

  const handleCampaignTypeChange = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedCampaignType = e.target.value as CampaignType;

    dispatch({
      type: 'selected_campaign_type_changed',
      payload: selectedCampaignType,
    });

    if (selectedCampaignType === 'cpg') {
      dispatch({
        type: 'selected_report_type_changed',
        payload: 'overall',
      });
    }
  };

  return (
    <RadioGroup
      value={filterState.selectedCampaignType}
      onChange={handleCampaignTypeChange}
    >
      <FormControlLabel
        value="all"
        control={<Radio />}
        label={campaignTypeLabels.all}
      />
      <FormControlLabel
        value="visitation"
        control={<Radio />}
        label={campaignTypeLabels.visitation}
      />
      <FormControlLabel
        value="cpg"
        control={<Radio />}
        label={campaignTypeLabels.cpg}
      />
      {features.rslCampaigns ? (
        <FormControlLabel
          value="rsl"
          control={<Radio />}
          label={campaignTypeLabels.rsl}
        />
      ) : null}
      {features.rslCampaigns ? (
        <FormControlLabel
          value="rslvisits"
          control={<Radio />}
          label={campaignTypeLabels.rslvisits}
        />
      ) : null}
    </RadioGroup>
  );
};
